var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"}),_c('div',{staticClass:"copyright pull-right"},[_vm._v(" VertiHub - Version "+_vm._s(_vm.version)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }